/**
 * A summary of a particular store.
 */
export class StoreSummary {
  slug: string;
  name: string;

  /**
   * @param slug the identifier of the store.
   * @param name the name of the store.
   */
  constructor(slug: string, name: string) {
    this.slug = slug;
    this.name = name;
  }
}
